import { CREATE_TARGET_GROUPS, GET_TARGET_GROUPS, PREVIEW_TARGET_GROUP, GET_TARGET_GROUP, UPDATE_CURRENT_TARGET_GROUP, RESET_CURRENT_TARGET_GROUP, GET_TARGET_GROUPS_BY_IDS } from "../constants/action-types";
import { ModelType } from "../constants/ModelType";

// export const ModelType = Object.freeze({
//   CUSTOMERS: "Customers",
//   PRODUCTS: "Products"
// })

// INITIALIZE STATE
const initialState = {
  targetGroups: {},
  currentModelType: ModelType.CUSTOMERS,
  targetGroupPreview: {},
  currentTargetGroup: {
    DisplayName: "",
    ModelType: ModelType.CUSTOMERS,
    TokenField: "id",
    ContainsAnyToken: [],
    SalesOrganisationIds: [],
    FilterRules: [],
    CallType: null
  }
};

// REDUCER
export const TargetGroupReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_TARGET_GROUPS: {
      const incomingTargetGroups = action.payload.data;
      const targetGroups = Object.assign({}, state.targetGroups);
      const currentModelType = action.payload.modelType;
      if (incomingTargetGroups.length === 0) {
        targetGroups[currentModelType] = []
      }

      if (currentModelType) {
        targetGroups[currentModelType] = {}
        incomingTargetGroups.forEach(targetGroup => {
          targetGroups[currentModelType][targetGroup.id] = targetGroup;
        });
      }

      return {
        ...state,
        targetGroups,
        currentModelType: currentModelType || ModelType.CUSTOMERS
      };
    }

    case GET_TARGET_GROUP: {
      const incomingTargetGroup = action.payload;
      const targetGroups = Object.assign({}, state.targetGroups);

      if (!targetGroups[incomingTargetGroup.ModelType]) {
        targetGroups[incomingTargetGroup.ModelType] = {}
      }

      targetGroups[incomingTargetGroup.ModelType][incomingTargetGroup.id] = incomingTargetGroup;

      return {
        ...state,
        currentTargetGroup: incomingTargetGroup,
        currentModelType: incomingTargetGroup.ModelType,
        targetGroups: targetGroups
      }
    }

    case GET_TARGET_GROUPS_BY_IDS: {
      const incomingTargetGroups = action.payload;
      const targetGroups = Object.assign({}, state.targetGroups);

      incomingTargetGroups.forEach(targetGroup => {
        const currentModelType = targetGroup.ModelType

        if (!targetGroups[currentModelType]) {
          targetGroups[currentModelType] = {}
        }

        targetGroups[currentModelType][targetGroup.id] = targetGroup;
      });

      return {
        ...state,
        targetGroups,
        currentModelType: ModelType.CUSTOMERS
      };
    }

    case CREATE_TARGET_GROUPS: {
      const targetGroups = Object.assign({}, state.targetGroups);
      const incomingTargetGroup = action.payload;
      const currentModelType = action.payload.ModelType;
      if (currentModelType) {
        if (!targetGroups[currentModelType]) {
          targetGroups[currentModelType] = {}
        }
        targetGroups[currentModelType][incomingTargetGroup.id] = incomingTargetGroup;
      }

      return {
        ...state,
        targetGroups,
        currentModelType: currentModelType || ModelType.CUSTOMERS
      };
    }

    case PREVIEW_TARGET_GROUP: {
      const previewTargetGroup = action.payload

      return {
        ...state,
        previewTargetGroup
      }
    }

    case UPDATE_CURRENT_TARGET_GROUP: {
      return {
        ...state,
        currentTargetGroup: action.payload
      }
    }

    case RESET_CURRENT_TARGET_GROUP: {
      return {
        ...state,
        currentTargetGroup: {
          DisplayName: "",
          ModelType: ModelType.CUSTOMERS,
          TokenField: "",
          ContainsAnyToken: [],
          FilterRules: []
        }
      }
    }

    default:
      return state;
  }
};
